import $ from 'jquery';
import './js/map.js';
